import { render, staticRenderFns } from "./ProductOtherCode.vue?vue&type=template&id=a541f672&"
import script from "./ProductOtherCode.vue?vue&type=script&lang=js&"
export * from "./ProductOtherCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports